module.exports = __webpack_public_path__ + "static/media/galerija_2016 (14).0bdb24d8.jpg";